export enum AccountsTagType {
    Passion = "passion",
    Description = "description"
}

export interface AccountsTag {
    id: string;
    key: string;
    label: string;
    type: AccountsTagType;
};
